module.exports = __webpack_public_path__ + "img/loading-bg.5638bb5f.jpg";